import { Outlet, createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "../../lib/auth-context.js";

/**
 * Layout for unauthenticated routes. If the user IS already authed,
 * bounce them to the dashboard rather than letting them re-see /login.
 * Page chrome (header, centering) is now owned by each child route so
 * that login/signup can use a full-bleed split layout while the
 * simpler pages (forgot/reset/verify) keep a centered card.
 */
export const Route = createFileRoute("/_public")({
  component: PublicLayout,
});

function PublicLayout() {
  const { status } = useAuth();
  if (status === "loading") {
    return <main style={{ padding: 96, textAlign: "center" }}>Loading…</main>;
  }
  if (status === "authed") return <Navigate to="/dashboard" />;
  return <Outlet />;
}
